import { z } from "zod/v4";

// CSP deliberately forbids dynamic code. Zod otherwise tests Function() once
// when constructing an object schema, producing a violation before it falls
// back to its interpreter. Configure this before loading application schemas.
z.config({ jitless: true });
